
import { computed, defineComponent, onMounted, PropType, ref } from 'vue';
import { useGeolocation } from 'vue-composable';
import { GeoPoint } from '@firebase/firestore-types';
import { useGoogleMaps } from '@/services';
import { geoPointToLatLng, geolocationCoordsToLatLng } from '@/utils';
import { emptyValues } from '@/constants';
import MaterialIcon from '@/components/MaterialIcon.vue';

export default defineComponent({
  name: 'GoogleMap',
  components: {
    MaterialIcon
  },
  props: {
    initialMarkerLocation: {
      type: Object as PropType<GeoPoint>,
      required: false
    }
  },
  setup(props) {
    const mapRef = ref<HTMLElement>();
    const { useMap, useLatLngOnClick, useOriginMarker } = useGoogleMaps();
    const [map, createMap] = useMap();
    const [, createLatLngOnClickListener] = useLatLngOnClick();
    const { setOriginMarker } = useOriginMarker();

    const { coords, refresh } = useGeolocation({ immediate: true });
    const currentLocation = computed<google.maps.LatLng>(() => geolocationCoordsToLatLng(coords));

    const centerButtonRef = ref<HTMLButtonElement>();
    const setCenter = () => {
      refresh();
      map.value?.setCenter(currentLocation.value);
    };

    onMounted(() => {
      if (mapRef.value) {
        createMap(mapRef.value);
        createLatLngOnClickListener();
        if (props.initialMarkerLocation && !props.initialMarkerLocation.isEqual(emptyValues.geoPoint)) {
          setOriginMarker(geoPointToLatLng(props.initialMarkerLocation));
          map.value?.setCenter(geoPointToLatLng(props.initialMarkerLocation));
        }
      }

      if (centerButtonRef.value) {
        map.value?.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(centerButtonRef.value);
      }
    });

    return {
      mapRef,
      setCenter,
      centerButtonRef
    };
  }
});
